"use strict";

var config = require('config');

(function () {

  angular.module("fleetviewApp").factory("tidLoginService", ["$http", "$q", "UserProvider", "Messages", "$window", function alkService($http, $q, UserProvider, Messages, $window) {
    var baseUrl = window.location.protocol + "//" + window.location.host;
    function getTidMigrationStatus(username) {
      var requestParams = {
        method: "POST",
        url: config.ssoUrl + "v1/trimbleid/migration-status",
        data: {
          email: username
        }
      };
      return $http(requestParams);
    }

    function tidSSOLogin(account, authCode) {
      var requestParams = {
        method: "POST",
        url: config.ssoUrl + "v1/trimbleid/authenticate",
        data: {
          authorizationCode: authCode,
          redirectUrl: baseUrl + "/tid/redirect",
          applicationName: config.applicationName,
          trimbleApplication: config.trimbleApplication,
          account: account
        },
        withCredentials: true
      };
      return $http(requestParams);
    }

    // Define the functions and properties to reveal.
    var service = {
      getTidMigrationStatus: getTidMigrationStatus,
      tidSSOLogin: tidSSOLogin
    };

    return service;
  }]);
})();


// WEBPACK FOOTER //
// ./app/auth/tidLogin.service.js